import Box from '@mui/material/Box';
import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { DataGridColumnHeaderWithToolTip } from '@verantos-dev/shared-components';

import { dataASINC } from '../data/data';
import type { AccuracyConcept } from '../types/types';

export const useAccuracyConceptList = () => {
  const intl = useIntl();
  const [openConfusionMatrixDialog, setOpenConfusionMatrixDialog] = useState(false);
  const [selectedConcept, setSelectedConcept] = useState<AccuracyConcept | null>(null);

  const gridMessages = {
    noRows: intl.formatMessage({ id: 'dataReliability.noRows' }),
  };

  const onConceptClick = (concept: AccuracyConcept) => {
    setSelectedConcept(concept);
    setOpenConfusionMatrixDialog(true);
  };

  const useFetchDataGridData = () => {
    return [];
  };

  // TODO: cleanup with data_reliability ff — Data Reliability is now a top-level,
  // project-independent page; it renders the static mock accuracy dataset until it is
  // wired to real accuracy data (data-administration accuracy-summaries endpoints).
  const gridData: AccuracyConcept[] = dataASINC;

  const accuracyTableColumns: GridColDef[] = [
    {
      field: 'conceptName',
      headerName: intl.formatMessage({ id: 'dataReliability.columnConcept' }),
      flex: 1,
      type: 'string',
      minWidth: 306,
      filterable: false,
      sortable: false,
      renderCell: (params: GridCellParams) => {
        return (
          <Box
            sx={{
              color: '#01579b',
              cursor: 'pointer',
            }}
            onClick={() => onConceptClick(params.row)}
          >
            {params.row.conceptName}
          </Box>
        );
      },
    },
    {
      field: 'recall',
      headerName: intl.formatMessage({ id: 'dataReliability.columnRecall' }),
      flex: 1,
      renderHeader: () => (
        <DataGridColumnHeaderWithToolTip
          id="accuracy-table-recall"
          headerName={intl.formatMessage({ id: 'dataReliability.columnRecall' })}
          description={intl.formatMessage({ id: 'dataReliability.columnRecall.tooltip' })}
          placement="left"
        />
      ),
    },
    {
      field: 'precision',
      headerName: intl.formatMessage({ id: 'dataReliability.columnPrecision' }),
      flex: 1,
      renderHeader: () => (
        <DataGridColumnHeaderWithToolTip
          id="accuracy-table-precision"
          headerName={intl.formatMessage({ id: 'dataReliability.columnPrecision' })}
          description={intl.formatMessage({ id: 'dataReliability.columnPrecision.tooltip' })}
          placement="left"
        />
      ),
    },
    {
      field: 'fMeasure',
      headerName: intl.formatMessage({ id: 'dataReliability.columnFMeasure' }),
      flex: 1,
      renderHeader: () => (
        <DataGridColumnHeaderWithToolTip
          id="accuracy-table-fmeasure"
          headerName={intl.formatMessage({ id: 'dataReliability.columnFMeasure' })}
          description={intl.formatMessage({ id: 'dataReliability.columnFMeasure.tooltip' })}
          placement="left"
        />
      ),
    },
  ];

  return {
    accuracyTableColumns,
    gridData,
    openConfusionMatrixDialog,
    setOpenConfusionMatrixDialog,
    selectedConcept,
    setSelectedConcept,
    useFetchDataGridData,
    gridMessages,
  };
};
